const SET_TOP_DESTINATIONS = (state, data) => {
  state.created = new Date().toString()
  state.topDestinations = data
}

const SET_GEOLOCATION = (state, data) => {
  state.geolocation = data
}

export default {
  SET_TOP_DESTINATIONS,
  SET_GEOLOCATION
}



// WEBPACK FOOTER //
// ./src/store/modules/communication/countries/mutations.js